import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ibiza_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const photoUrl = (id) => `${API}/files/photo/${id}`;
export const proofUrl = (id) => `${API}/files/proof/${id}`;
export const gcashQrUrl = () => `${API}/files/gcash-qr`;
export const videoUrl = (id) => `${API}/files/video/${id}`;
export const videoPosterUrl = (id) => `${API}/files/video/${id}/poster`;

export const formatPHP = (n) =>
  new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    maximumFractionDigits: 0,
  }).format(n || 0);

const PHT = "Asia/Manila";

// Format an ISO date string (YYYY-MM-DD) into "Mon, Jan 5, 2026" using Asia/Manila.
export const formatPHTDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(`${iso}T00:00:00+08:00`);
    return new Intl.DateTimeFormat("en-PH", {
      timeZone: PHT,
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(d);
  } catch {
    return iso;
  }
};

// Format an ISO timestamp (with TZ) as "Feb 27, 2026, 3:45 PM" in PHT.
export const formatPHTDateTime = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const s = new Intl.DateTimeFormat("en-PH", {
      timeZone: PHT,
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(d);
    return `${s} (PHT)`;
  } catch {
    return iso;
  }
};
